var _defs, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg9(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_design",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2af598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009efd"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_12374",
    "data-name": "Path 12374",
    d: "M306.573,346a.573.573,0,1,0,.573.573A.573.573,0,0,0,306.573,346Zm0,0",
    transform: "translate(-288.054 -325.708)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12375",
    "data-name": "Path 12375",
    d: "M27.07,0H2.93A2.933,2.933,0,0,0,0,2.93v17.93a2.933,2.933,0,0,0,2.93,2.93H12.07v2.7h-.586a2.93,2.93,0,0,0-2.93,2.93A.586.586,0,0,0,9.141,30H20.859a.586.586,0,0,0,.586-.586,2.933,2.933,0,0,0-2.93-2.93H17.93v-2.7H27.07A2.933,2.933,0,0,0,30,20.859V2.93A2.933,2.933,0,0,0,27.07,0ZM2.93,1.172H27.07A1.76,1.76,0,0,1,28.828,2.93v15h-2.7V4.453a.586.586,0,0,0-.586-.586H20.859a.586.586,0,0,0-.586.586V17.93H17.341c-.006-.606-.022-1.2-.047-1.783a37.688,37.688,0,0,0-.458-4.688,2.93,2.93,0,0,0,.8-3.822L15.6,4.12a.586.586,0,0,0-1.015,0L12.558,7.637a2.929,2.929,0,0,0,.645,3.7,37.2,37.2,0,0,0-.494,4.811c-.026.586-.043,1.184-.049,1.784H9.727V9.141a.583.583,0,0,0-.058-.253l0-.009L7.321,4.191a.586.586,0,0,0-1.048,0L3.929,8.879l0,.009a.582.582,0,0,0-.058.253V17.93h-2.7v-15A1.76,1.76,0,0,1,2.93,1.172ZM21.445,17.93V5.039h3.516V6.211h-.586a.586.586,0,0,0,0,1.172h.586V9.141h-.586a.586.586,0,1,0,0,1.172h.586V12.07h-.586a.586.586,0,0,0,0,1.172h.586v2.344h-.586a.586.586,0,1,0,0,1.172h.586V17.93ZM15.1,12.03a2.934,2.934,0,0,0,.632-.07c.109.7.268,1.93.363,3.626H13.911c.1-1.7.266-2.948.382-3.668a2.933,2.933,0,0,0,.8.112Zm0-1.172a1.76,1.76,0,0,1-1.524-2.635L15.1,5.585,16.62,8.223A1.759,1.759,0,0,1,15.1,10.858Zm-1.24,5.9h2.286c.012.385.021.777.025,1.172H13.831c0-.393.013-.784.026-1.172ZM7.383,17.93v-8.2H8.555v8.2Zm-2.344,0v-8.2H6.211v8.2ZM5.4,8.555,6.8,5.763l1.4,2.791ZM20.173,28.828H9.826a1.761,1.761,0,0,1,1.658-1.172h7.031a1.761,1.761,0,0,1,1.657,1.172Zm-3.415-2.344H13.242v-2.7h3.516ZM27.07,22.617H2.93a1.76,1.76,0,0,1-1.758-1.758V19.1H28.828v1.758A1.76,1.76,0,0,1,27.07,22.617Zm0,0",
    fill: "url(#linear-gradient)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12376",
    "data-name": "Path 12376",
    d: "M210.009,346h-3.436a.573.573,0,1,0,0,1.146h3.436a.573.573,0,0,0,0-1.146Zm0,0",
    transform: "translate(-193.879 -325.708)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg9);
export default __webpack_public_path__ + "static/media/9.88f5c157e9adbda0db8c42e6470d0858.svg";
export { ForwardRef as ReactComponent };